import React, { Component } from "react";

import moment from "moment";
import "./style.css";
class CountDownSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const { timeTillDate, timeFormat } = this.props;
      const then = moment(timeTillDate, timeFormat);

      const currentTime = moment(new Date()).format("MM DD YYYY, HH:mm:ss");
      const now = moment(currentTime, timeFormat);
      let calculateDate = then.diff(now);

      const days = Math.floor(calculateDate / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (calculateDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (calculateDate % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((calculateDate % (1000 * 60)) / 1000);

      this.setState({ days, hours, minutes, seconds });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval < 0) {
      clearInterval(this.interval);
    }
  }
  render() {
    const { days, hours, minutes, seconds } = this.state;
    return (
      <ul className="countdown">
        <li>
          <span className="days mr-1">{days > 0 ? days : `00`}d:</span>
        </li>
        <li>
          <span className="hours ml-1 mr-1">{hours > 0 ? hours : `00`}h:</span>
        </li>
        <li>
          <span className="minutes ml-1 mr-1">
            {minutes > 0 ? minutes : `00`}m:
          </span>
        </li>
        <li>
          <span className="seconds ml-1">
            {seconds > 0 ? seconds : `00`} seconds
          </span>
        </li>
      </ul>
    );
  }
}

export default CountDownSimple;
